import clsx from 'clsx';

import ChevronDown from '~/icons/chevron-down.svg';
import { INavigationNode } from '~/lib/data-contract';
import { Accordion } from '~/shared/components/Accordion/Accordion';
import { AccordionItem } from '~/shared/components/Accordion/components/AccordionItem/AccordionItem';
import { Icon } from '~/shared/components/Icon/Icon';
import { Text } from '~/shared/components/Text/Text';

import styles from './footerNavigationContainer.module.css';

import { FooterNavigation } from '../FooterNavigation/FooterNavigation';

export type FooterNavigationContainerProps = {
	title?: string;
	navigationItems?: INavigationNode[];
	enableMultiColumns?: boolean;
	hasBorder?: boolean;
};

export const FooterNavigationContainer = ({ navigationItems, title, enableMultiColumns, hasBorder }: FooterNavigationContainerProps) => {
	if (!title && !navigationItems) {
		return null;
	}

	return (
		<>
			<Accordion className={styles.mobile}>
				<AccordionItem
					className={styles.accordionItem}
					header={
						<Text
							as="h4"
							variant="bodySmBold"
						>
							{title}
						</Text>
					}
					initAsOpen={false}
					icon={
						<Icon size={'lg'}>
							<ChevronDown />
						</Icon>
					}
				>
					<FooterNavigation navigationItems={navigationItems}></FooterNavigation>
				</AccordionItem>
			</Accordion>

			<div className={clsx(styles.desktop, hasBorder && styles.hasBorder)}>
				<FooterNavigation
					title={title}
					navigationItems={navigationItems}
					enableMultiColumns={enableMultiColumns}
				></FooterNavigation>
			</div>
		</>
	);
};
